import { render, staticRenderFns } from "./DistributionView.vue?vue&type=template&id=0bb45366&scoped=true"
import script from "./DistributionView.vue?vue&type=script&lang=js"
export * from "./DistributionView.vue?vue&type=script&lang=js"
import style0 from "./DistributionView.vue?vue&type=style&index=0&id=0bb45366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb45366",
  null
  
)

export default component.exports